import Background from "./components/layout/Background";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Web3OnboardWrapper from "./Web3OnboardWrapper";
import SelectWallet from "./SelectWallet";

function Page() {
  return (
    <>
      <Web3OnboardWrapper>
        <Background />
        <Header />

        <div className="main-container wider" id="main-container">
          <div className="card">
            <div className="card-body text-black p-0 mb-4">
              <div className="d-flex flex-column">
                <SelectWallet></SelectWallet>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Web3OnboardWrapper>
    </>
  );
}

export default Page;
